"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Training Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.106
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingProfileApi = exports.TrainingProfileApiFactory = exports.TrainingProfileApiFp = exports.TrainingProfileApiAxiosParamCreator = exports.TrainingModifierApi = exports.TrainingModifierApiFactory = exports.TrainingModifierApiFp = exports.TrainingModifierApiAxiosParamCreator = exports.IndividualisedSettingsApi = exports.IndividualisedSettingsApiFactory = exports.IndividualisedSettingsApiFp = exports.IndividualisedSettingsApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FarmerTrainingGuideApi = exports.FarmerTrainingGuideApiFactory = exports.FarmerTrainingGuideApiFp = exports.FarmerTrainingGuideApiAxiosParamCreator = exports.ApplyProfilesApi = exports.ApplyProfilesApiFactory = exports.ApplyProfilesApiFp = exports.ApplyProfilesApiAxiosParamCreator = exports.ApplyModifiersApi = exports.ApplyModifiersApiFactory = exports.ApplyModifiersApiFp = exports.ApplyModifiersApiAxiosParamCreator = exports.UpdateType = exports.TransitionStageEnum = exports.TrainingSettingsTypeEnum = exports.IPatchModifierActionEnum = exports.FarmerTrainingGuideTypeEnum = exports.FarmTrainingStatusEnum = exports.DefaultProfileApplyConditionEnum = exports.BreakFenceCreationStageEnum = exports.AutoApplyModifierConditionEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AutoApplyModifierConditionEnum = {
    CALVING: 'CALVING',
    HARD_LOCK_OUT: 'HARD_LOCK_OUT',
    SHOCK_LEVEL: 'SHOCK_LEVEL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BreakFenceCreationStageEnum = {
    STAGE_A: 'STAGE_A',
    STAGE_B: 'STAGE_B',
    STAGE_C: 'STAGE_C',
    STAGE_D: 'STAGE_D',
    STAGE_E: 'STAGE_E',
    COMPLETED: 'COMPLETED'
};
/**
 * Condition for when is this default profile applied
 * @export
 * @enum {string}
 */
exports.DefaultProfileApplyConditionEnum = {
    DAIRY_FARM_DEFAULT: 'DAIRY_FARM_DEFAULT',
    BEEF_FARM_DEFAULT: 'BEEF_FARM_DEFAULT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FarmTrainingStatusEnum = {
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FarmerTrainingGuideTypeEnum = {
    BREAK_FENCE_CREATION: 'BREAK_FENCE_CREATION',
    TRANSITIONS: 'TRANSITIONS'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IPatchModifierActionEnum = {
    APPLY: 'APPLY',
    UNAPPLY: 'UNAPPLY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TrainingSettingsTypeEnum = {
    HOLD_IN_ZONE: 'HOLD_IN_ZONE',
    ENTER_PADDOCK: 'ENTER_PADDOCK',
    EXIT_PADDOCK: 'EXIT_PADDOCK',
    EXIT_PADDOCK_DRAFTING: 'EXIT_PADDOCK_DRAFTING',
    BREAK_TO_BREAK: 'BREAK_TO_BREAK',
    RACE_NAVIGATION: 'RACE_NAVIGATION',
    HOLD_IN_ZONE_CROP: 'HOLD_IN_ZONE_CROP',
    BREAK_TO_BREAK_CROP: 'BREAK_TO_BREAK_CROP',
    EXIT_PADDOCK_CROP: 'EXIT_PADDOCK_CROP',
    SHARED_BOUNDARY_TRANSITION: 'SHARED_BOUNDARY_TRANSITION',
    ENTER_SHARED_BOUNDARY: 'ENTER_SHARED_BOUNDARY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TransitionStageEnum = {
    STAGE_A: 'STAGE_A',
    STAGE_B: 'STAGE_B',
    STAGE_C: 'STAGE_C',
    STAGE_D: 'STAGE_D',
    STAGE_E: 'STAGE_E',
    COMPLETED: 'COMPLETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UpdateType = {
    CREATED: 'CREATED',
    DELETED: 'DELETED',
    UPDATED: 'UPDATED'
};
/**
 * ApplyModifiersApi - axios parameter creator
 * @export
 */
var ApplyModifiersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Applies a set of training modifiers to a list of cows, deleting any other applied modifiers.
         * @param {IApplyModifiersRequestDTO} [iApplyModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkApplyModifiers: function (iApplyModifiersRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-modifiers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iApplyModifiersRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Applies or unapplies a set of training modifiers to a list of cows, keeping any other applied modifiers.
         * @param {IPatchModifiersRequestDTO} [iPatchModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPatchModifiers: function (iPatchModifiersRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-modifiers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iPatchModifiersRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves the applied modifiers for list of cows
         * @param {Array<string>} [cattleIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedModifiers: function (cattleIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-modifiers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleIds) {
                        localVarQueryParameter['cattleIds'] = cattleIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplyModifiersApiAxiosParamCreator = ApplyModifiersApiAxiosParamCreator;
/**
 * ApplyModifiersApi - functional programming interface
 * @export
 */
var ApplyModifiersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplyModifiersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Applies a set of training modifiers to a list of cows, deleting any other applied modifiers.
         * @param {IApplyModifiersRequestDTO} [iApplyModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkApplyModifiers: function (iApplyModifiersRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkApplyModifiers(iApplyModifiersRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Applies or unapplies a set of training modifiers to a list of cows, keeping any other applied modifiers.
         * @param {IPatchModifiersRequestDTO} [iPatchModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPatchModifiers: function (iPatchModifiersRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkPatchModifiers(iPatchModifiersRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves the applied modifiers for list of cows
         * @param {Array<string>} [cattleIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedModifiers: function (cattleIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllAppliedModifiers(cattleIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplyModifiersApiFp = ApplyModifiersApiFp;
/**
 * ApplyModifiersApi - factory interface
 * @export
 */
var ApplyModifiersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplyModifiersApiFp)(configuration);
    return {
        /**
         *
         * @summary Applies a set of training modifiers to a list of cows, deleting any other applied modifiers.
         * @param {IApplyModifiersRequestDTO} [iApplyModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkApplyModifiers: function (iApplyModifiersRequestDTO, options) {
            return localVarFp.bulkApplyModifiers(iApplyModifiersRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Applies or unapplies a set of training modifiers to a list of cows, keeping any other applied modifiers.
         * @param {IPatchModifiersRequestDTO} [iPatchModifiersRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPatchModifiers: function (iPatchModifiersRequestDTO, options) {
            return localVarFp.bulkPatchModifiers(iPatchModifiersRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves the applied modifiers for list of cows
         * @param {Array<string>} [cattleIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedModifiers: function (cattleIds, options) {
            return localVarFp.findAllAppliedModifiers(cattleIds, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplyModifiersApiFactory = ApplyModifiersApiFactory;
/**
 * ApplyModifiersApi - object-oriented interface
 * @export
 * @class ApplyModifiersApi
 * @extends {BaseAPI}
 */
var ApplyModifiersApi = /** @class */ (function (_super) {
    __extends(ApplyModifiersApi, _super);
    function ApplyModifiersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Applies a set of training modifiers to a list of cows, deleting any other applied modifiers.
     * @param {IApplyModifiersRequestDTO} [iApplyModifiersRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModifiersApi
     */
    ApplyModifiersApi.prototype.bulkApplyModifiers = function (iApplyModifiersRequestDTO, options) {
        var _this = this;
        return (0, exports.ApplyModifiersApiFp)(this.configuration).bulkApplyModifiers(iApplyModifiersRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Applies or unapplies a set of training modifiers to a list of cows, keeping any other applied modifiers.
     * @param {IPatchModifiersRequestDTO} [iPatchModifiersRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModifiersApi
     */
    ApplyModifiersApi.prototype.bulkPatchModifiers = function (iPatchModifiersRequestDTO, options) {
        var _this = this;
        return (0, exports.ApplyModifiersApiFp)(this.configuration).bulkPatchModifiers(iPatchModifiersRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves the applied modifiers for list of cows
     * @param {Array<string>} [cattleIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModifiersApi
     */
    ApplyModifiersApi.prototype.findAllAppliedModifiers = function (cattleIds, options) {
        var _this = this;
        return (0, exports.ApplyModifiersApiFp)(this.configuration).findAllAppliedModifiers(cattleIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplyModifiersApi;
}(base_1.BaseAPI));
exports.ApplyModifiersApi = ApplyModifiersApi;
/**
 * ApplyProfilesApi - axios parameter creator
 * @export
 */
var ApplyProfilesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Applies a training profile to a farm.
         * @param {IApplyProfilesRequestDTO} [iApplyProfilesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyProfiles: function (iApplyProfilesRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-profiles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iApplyProfilesRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a default training profile
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDefaultTrainingProfile: function (iDefaultTrainingProfileRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-profiles/default";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDefaultTrainingProfileRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves all training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedProfiles: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-profiles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves all default training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDefaultTrainingProfiles: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-profiles/default";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Any new farms will be created with these defaults, depending on type and apply conditions
         * @summary Assigns a default training profile for a settings type
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultTrainingProfiles: function (iDefaultTrainingProfileRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/applied-profiles/default";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDefaultTrainingProfileRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplyProfilesApiAxiosParamCreator = ApplyProfilesApiAxiosParamCreator;
/**
 * ApplyProfilesApi - functional programming interface
 * @export
 */
var ApplyProfilesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplyProfilesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Applies a training profile to a farm.
         * @param {IApplyProfilesRequestDTO} [iApplyProfilesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyProfiles: function (iApplyProfilesRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applyProfiles(iApplyProfilesRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a default training profile
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDefaultTrainingProfile: function (iDefaultTrainingProfileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDefaultTrainingProfile(iDefaultTrainingProfileRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedProfiles: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllAppliedProfiles(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all default training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDefaultTrainingProfiles: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllDefaultTrainingProfiles(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Any new farms will be created with these defaults, depending on type and apply conditions
         * @summary Assigns a default training profile for a settings type
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultTrainingProfiles: function (iDefaultTrainingProfileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setDefaultTrainingProfiles(iDefaultTrainingProfileRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplyProfilesApiFp = ApplyProfilesApiFp;
/**
 * ApplyProfilesApi - factory interface
 * @export
 */
var ApplyProfilesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplyProfilesApiFp)(configuration);
    return {
        /**
         *
         * @summary Applies a training profile to a farm.
         * @param {IApplyProfilesRequestDTO} [iApplyProfilesRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyProfiles: function (iApplyProfilesRequestDTO, options) {
            return localVarFp.applyProfiles(iApplyProfilesRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a default training profile
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDefaultTrainingProfile: function (iDefaultTrainingProfileRequestDTO, options) {
            return localVarFp.deleteDefaultTrainingProfile(iDefaultTrainingProfileRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliedProfiles: function (options) {
            return localVarFp.findAllAppliedProfiles(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all default training profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDefaultTrainingProfiles: function (options) {
            return localVarFp.findAllDefaultTrainingProfiles(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Any new farms will be created with these defaults, depending on type and apply conditions
         * @summary Assigns a default training profile for a settings type
         * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultTrainingProfiles: function (iDefaultTrainingProfileRequestDTO, options) {
            return localVarFp.setDefaultTrainingProfiles(iDefaultTrainingProfileRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplyProfilesApiFactory = ApplyProfilesApiFactory;
/**
 * ApplyProfilesApi - object-oriented interface
 * @export
 * @class ApplyProfilesApi
 * @extends {BaseAPI}
 */
var ApplyProfilesApi = /** @class */ (function (_super) {
    __extends(ApplyProfilesApi, _super);
    function ApplyProfilesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Applies a training profile to a farm.
     * @param {IApplyProfilesRequestDTO} [iApplyProfilesRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyProfilesApi
     */
    ApplyProfilesApi.prototype.applyProfiles = function (iApplyProfilesRequestDTO, options) {
        var _this = this;
        return (0, exports.ApplyProfilesApiFp)(this.configuration).applyProfiles(iApplyProfilesRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a default training profile
     * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyProfilesApi
     */
    ApplyProfilesApi.prototype.deleteDefaultTrainingProfile = function (iDefaultTrainingProfileRequestDTO, options) {
        var _this = this;
        return (0, exports.ApplyProfilesApiFp)(this.configuration).deleteDefaultTrainingProfile(iDefaultTrainingProfileRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all training profiles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyProfilesApi
     */
    ApplyProfilesApi.prototype.findAllAppliedProfiles = function (options) {
        var _this = this;
        return (0, exports.ApplyProfilesApiFp)(this.configuration).findAllAppliedProfiles(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all default training profiles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyProfilesApi
     */
    ApplyProfilesApi.prototype.findAllDefaultTrainingProfiles = function (options) {
        var _this = this;
        return (0, exports.ApplyProfilesApiFp)(this.configuration).findAllDefaultTrainingProfiles(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Any new farms will be created with these defaults, depending on type and apply conditions
     * @summary Assigns a default training profile for a settings type
     * @param {IDefaultTrainingProfileRequestDTO} [iDefaultTrainingProfileRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyProfilesApi
     */
    ApplyProfilesApi.prototype.setDefaultTrainingProfiles = function (iDefaultTrainingProfileRequestDTO, options) {
        var _this = this;
        return (0, exports.ApplyProfilesApiFp)(this.configuration).setDefaultTrainingProfiles(iDefaultTrainingProfileRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplyProfilesApi;
}(base_1.BaseAPI));
exports.ApplyProfilesApi = ApplyProfilesApi;
/**
 * FarmerTrainingGuideApi - axios parameter creator
 * @export
 */
var FarmerTrainingGuideApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieves options for the requested farmer training guide
         * @param {string} farmId Farm Identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuideOptions: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmerTrainingGuideOptions', 'farmId', farmId);
                    localVarPath = "/training/farmer-training-guide/{farmId}/options"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves farmer training guides for the requested farm
         * @param {string} farmId Farm identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuides: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmerTrainingGuides', 'farmId', farmId);
                    localVarPath = "/training/farmer-training-guide/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Sets current stage of the farmer training guide to the requested stage, creates if not exist
         * @param {IUpsertCurrentStageRequestDTO} [iUpsertCurrentStageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCurrentStage: function (iUpsertCurrentStageRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/farmer-training-guide/current-stage";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertCurrentStageRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates or creates the requested farmer training guide options
         * @param {string} farmId Farm Identifier
         * @param {IUpsertFarmerTrainingGuideOptionsRequestDTO} [iUpsertFarmerTrainingGuideOptionsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFarmerTrainingGuideOptions: function (farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('upsertFarmerTrainingGuideOptions', 'farmId', farmId);
                    localVarPath = "/training/farmer-training-guide/{farmId}/options"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertFarmerTrainingGuideOptionsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmerTrainingGuideApiAxiosParamCreator = FarmerTrainingGuideApiAxiosParamCreator;
/**
 * FarmerTrainingGuideApi - functional programming interface
 * @export
 */
var FarmerTrainingGuideApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmerTrainingGuideApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieves options for the requested farmer training guide
         * @param {string} farmId Farm Identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuideOptions: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findFarmerTrainingGuideOptions(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves farmer training guides for the requested farm
         * @param {string} farmId Farm identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuides: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findFarmerTrainingGuides(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sets current stage of the farmer training guide to the requested stage, creates if not exist
         * @param {IUpsertCurrentStageRequestDTO} [iUpsertCurrentStageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCurrentStage: function (iUpsertCurrentStageRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertCurrentStage(iUpsertCurrentStageRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates or creates the requested farmer training guide options
         * @param {string} farmId Farm Identifier
         * @param {IUpsertFarmerTrainingGuideOptionsRequestDTO} [iUpsertFarmerTrainingGuideOptionsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFarmerTrainingGuideOptions: function (farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertFarmerTrainingGuideOptions(farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmerTrainingGuideApiFp = FarmerTrainingGuideApiFp;
/**
 * FarmerTrainingGuideApi - factory interface
 * @export
 */
var FarmerTrainingGuideApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmerTrainingGuideApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieves options for the requested farmer training guide
         * @param {string} farmId Farm Identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuideOptions: function (farmId, options) {
            return localVarFp.findFarmerTrainingGuideOptions(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves farmer training guides for the requested farm
         * @param {string} farmId Farm identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmerTrainingGuides: function (farmId, options) {
            return localVarFp.findFarmerTrainingGuides(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sets current stage of the farmer training guide to the requested stage, creates if not exist
         * @param {IUpsertCurrentStageRequestDTO} [iUpsertCurrentStageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCurrentStage: function (iUpsertCurrentStageRequestDTO, options) {
            return localVarFp.upsertCurrentStage(iUpsertCurrentStageRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates or creates the requested farmer training guide options
         * @param {string} farmId Farm Identifier
         * @param {IUpsertFarmerTrainingGuideOptionsRequestDTO} [iUpsertFarmerTrainingGuideOptionsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFarmerTrainingGuideOptions: function (farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options) {
            return localVarFp.upsertFarmerTrainingGuideOptions(farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmerTrainingGuideApiFactory = FarmerTrainingGuideApiFactory;
/**
 * FarmerTrainingGuideApi - object-oriented interface
 * @export
 * @class FarmerTrainingGuideApi
 * @extends {BaseAPI}
 */
var FarmerTrainingGuideApi = /** @class */ (function (_super) {
    __extends(FarmerTrainingGuideApi, _super);
    function FarmerTrainingGuideApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves options for the requested farmer training guide
     * @param {string} farmId Farm Identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmerTrainingGuideApi
     */
    FarmerTrainingGuideApi.prototype.findFarmerTrainingGuideOptions = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmerTrainingGuideApiFp)(this.configuration).findFarmerTrainingGuideOptions(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves farmer training guides for the requested farm
     * @param {string} farmId Farm identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmerTrainingGuideApi
     */
    FarmerTrainingGuideApi.prototype.findFarmerTrainingGuides = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmerTrainingGuideApiFp)(this.configuration).findFarmerTrainingGuides(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sets current stage of the farmer training guide to the requested stage, creates if not exist
     * @param {IUpsertCurrentStageRequestDTO} [iUpsertCurrentStageRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmerTrainingGuideApi
     */
    FarmerTrainingGuideApi.prototype.upsertCurrentStage = function (iUpsertCurrentStageRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmerTrainingGuideApiFp)(this.configuration).upsertCurrentStage(iUpsertCurrentStageRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates or creates the requested farmer training guide options
     * @param {string} farmId Farm Identifier
     * @param {IUpsertFarmerTrainingGuideOptionsRequestDTO} [iUpsertFarmerTrainingGuideOptionsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmerTrainingGuideApi
     */
    FarmerTrainingGuideApi.prototype.upsertFarmerTrainingGuideOptions = function (farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmerTrainingGuideApiFp)(this.configuration).upsertFarmerTrainingGuideOptions(farmId, iUpsertFarmerTrainingGuideOptionsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmerTrainingGuideApi;
}(base_1.BaseAPI));
exports.FarmerTrainingGuideApi = FarmerTrainingGuideApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainingHealthcheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/healthcheck";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainingHealthcheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trainingHealthcheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainingHealthcheckGet: function (options) {
            return localVarFp.trainingHealthcheckGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.trainingHealthcheckGet = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).trainingHealthcheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * IndividualisedSettingsApi - axios parameter creator
 * @export
 */
var IndividualisedSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Analyse cows\' performances by starting a query execution.
         * @param {string} farmId Farm to run individualised settings on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyseIndividualisedSettings: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('analyseIndividualisedSettings', 'farmId', farmId);
                    localVarPath = "/training/individualised-settings/analyse/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.IndividualisedSettingsApiAxiosParamCreator = IndividualisedSettingsApiAxiosParamCreator;
/**
 * IndividualisedSettingsApi - functional programming interface
 * @export
 */
var IndividualisedSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IndividualisedSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Analyse cows\' performances by starting a query execution.
         * @param {string} farmId Farm to run individualised settings on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyseIndividualisedSettings: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.analyseIndividualisedSettings(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IndividualisedSettingsApiFp = IndividualisedSettingsApiFp;
/**
 * IndividualisedSettingsApi - factory interface
 * @export
 */
var IndividualisedSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IndividualisedSettingsApiFp)(configuration);
    return {
        /**
         *
         * @summary Analyse cows\' performances by starting a query execution.
         * @param {string} farmId Farm to run individualised settings on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyseIndividualisedSettings: function (farmId, options) {
            return localVarFp.analyseIndividualisedSettings(farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IndividualisedSettingsApiFactory = IndividualisedSettingsApiFactory;
/**
 * IndividualisedSettingsApi - object-oriented interface
 * @export
 * @class IndividualisedSettingsApi
 * @extends {BaseAPI}
 */
var IndividualisedSettingsApi = /** @class */ (function (_super) {
    __extends(IndividualisedSettingsApi, _super);
    function IndividualisedSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Analyse cows\' performances by starting a query execution.
     * @param {string} farmId Farm to run individualised settings on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualisedSettingsApi
     */
    IndividualisedSettingsApi.prototype.analyseIndividualisedSettings = function (farmId, options) {
        var _this = this;
        return (0, exports.IndividualisedSettingsApiFp)(this.configuration).analyseIndividualisedSettings(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IndividualisedSettingsApi;
}(base_1.BaseAPI));
exports.IndividualisedSettingsApi = IndividualisedSettingsApi;
/**
 * TrainingModifierApi - axios parameter creator
 * @export
 */
var TrainingModifierApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Creates a training modifier
         * @param {ICreateTrainingModifierRequestDTO} [iCreateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModifier: function (iCreateTrainingModifierRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/modifiers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTrainingModifierRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModifier: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteModifier', 'id', id);
                    localVarPath = "/training/modifiers/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves all training modifiers associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllModifiers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/modifiers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves training modifier by id
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findModifierById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('findModifierById', 'id', id);
                    localVarPath = "/training/modifiers/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a training modifier
         * @param {string} id Training modifier id
         * @param {IUpdateTrainingModifierRequestDTO} [iUpdateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModifier: function (id, iUpdateTrainingModifierRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateModifier', 'id', id);
                    localVarPath = "/training/modifiers/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTrainingModifierRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TrainingModifierApiAxiosParamCreator = TrainingModifierApiAxiosParamCreator;
/**
 * TrainingModifierApi - functional programming interface
 * @export
 */
var TrainingModifierApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrainingModifierApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Creates a training modifier
         * @param {ICreateTrainingModifierRequestDTO} [iCreateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModifier: function (iCreateTrainingModifierRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createModifier(iCreateTrainingModifierRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModifier: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteModifier(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all training modifiers associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllModifiers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllModifiers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves training modifier by id
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findModifierById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findModifierById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a training modifier
         * @param {string} id Training modifier id
         * @param {IUpdateTrainingModifierRequestDTO} [iUpdateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModifier: function (id, iUpdateTrainingModifierRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateModifier(id, iUpdateTrainingModifierRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrainingModifierApiFp = TrainingModifierApiFp;
/**
 * TrainingModifierApi - factory interface
 * @export
 */
var TrainingModifierApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrainingModifierApiFp)(configuration);
    return {
        /**
         *
         * @summary Creates a training modifier
         * @param {ICreateTrainingModifierRequestDTO} [iCreateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModifier: function (iCreateTrainingModifierRequestDTO, options) {
            return localVarFp.createModifier(iCreateTrainingModifierRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModifier: function (id, options) {
            return localVarFp.deleteModifier(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all training modifiers associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllModifiers: function (options) {
            return localVarFp.findAllModifiers(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves training modifier by id
         * @param {string} id Training modifier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findModifierById: function (id, options) {
            return localVarFp.findModifierById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a training modifier
         * @param {string} id Training modifier id
         * @param {IUpdateTrainingModifierRequestDTO} [iUpdateTrainingModifierRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModifier: function (id, iUpdateTrainingModifierRequestDTO, options) {
            return localVarFp.updateModifier(id, iUpdateTrainingModifierRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrainingModifierApiFactory = TrainingModifierApiFactory;
/**
 * TrainingModifierApi - object-oriented interface
 * @export
 * @class TrainingModifierApi
 * @extends {BaseAPI}
 */
var TrainingModifierApi = /** @class */ (function (_super) {
    __extends(TrainingModifierApi, _super);
    function TrainingModifierApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Creates a training modifier
     * @param {ICreateTrainingModifierRequestDTO} [iCreateTrainingModifierRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingModifierApi
     */
    TrainingModifierApi.prototype.createModifier = function (iCreateTrainingModifierRequestDTO, options) {
        var _this = this;
        return (0, exports.TrainingModifierApiFp)(this.configuration).createModifier(iCreateTrainingModifierRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a training profile
     * @param {string} id Training modifier id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingModifierApi
     */
    TrainingModifierApi.prototype.deleteModifier = function (id, options) {
        var _this = this;
        return (0, exports.TrainingModifierApiFp)(this.configuration).deleteModifier(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all training modifiers associated with context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingModifierApi
     */
    TrainingModifierApi.prototype.findAllModifiers = function (options) {
        var _this = this;
        return (0, exports.TrainingModifierApiFp)(this.configuration).findAllModifiers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves training modifier by id
     * @param {string} id Training modifier id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingModifierApi
     */
    TrainingModifierApi.prototype.findModifierById = function (id, options) {
        var _this = this;
        return (0, exports.TrainingModifierApiFp)(this.configuration).findModifierById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a training modifier
     * @param {string} id Training modifier id
     * @param {IUpdateTrainingModifierRequestDTO} [iUpdateTrainingModifierRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingModifierApi
     */
    TrainingModifierApi.prototype.updateModifier = function (id, iUpdateTrainingModifierRequestDTO, options) {
        var _this = this;
        return (0, exports.TrainingModifierApiFp)(this.configuration).updateModifier(id, iUpdateTrainingModifierRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrainingModifierApi;
}(base_1.BaseAPI));
exports.TrainingModifierApi = TrainingModifierApi;
/**
 * TrainingProfileApi - axios parameter creator
 * @export
 */
var TrainingProfileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Creates a training profile
         * @param {ICreateTrainingProfileRequestDTO} [iCreateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile: function (iCreateTrainingProfileRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/profiles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTrainingProfileRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteProfile', 'id', id);
                    localVarPath = "/training/profiles/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves all training profiles associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProfiles: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/training/profiles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves training profile by id
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProfileById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('findProfileById', 'id', id);
                    localVarPath = "/training/profiles/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a training profile
         * @param {string} id Training profile id
         * @param {IUpdateTrainingProfileRequestDTO} [iUpdateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (id, iUpdateTrainingProfileRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateProfile', 'id', id);
                    localVarPath = "/training/profiles/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTrainingProfileRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TrainingProfileApiAxiosParamCreator = TrainingProfileApiAxiosParamCreator;
/**
 * TrainingProfileApi - functional programming interface
 * @export
 */
var TrainingProfileApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrainingProfileApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Creates a training profile
         * @param {ICreateTrainingProfileRequestDTO} [iCreateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile: function (iCreateTrainingProfileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProfile(iCreateTrainingProfileRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProfile(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all training profiles associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProfiles: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllProfiles(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves training profile by id
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProfileById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findProfileById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a training profile
         * @param {string} id Training profile id
         * @param {IUpdateTrainingProfileRequestDTO} [iUpdateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (id, iUpdateTrainingProfileRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProfile(id, iUpdateTrainingProfileRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrainingProfileApiFp = TrainingProfileApiFp;
/**
 * TrainingProfileApi - factory interface
 * @export
 */
var TrainingProfileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrainingProfileApiFp)(configuration);
    return {
        /**
         *
         * @summary Creates a training profile
         * @param {ICreateTrainingProfileRequestDTO} [iCreateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile: function (iCreateTrainingProfileRequestDTO, options) {
            return localVarFp.createProfile(iCreateTrainingProfileRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a training profile
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (id, options) {
            return localVarFp.deleteProfile(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all training profiles associated with context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProfiles: function (options) {
            return localVarFp.findAllProfiles(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves training profile by id
         * @param {string} id Training profile id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProfileById: function (id, options) {
            return localVarFp.findProfileById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a training profile
         * @param {string} id Training profile id
         * @param {IUpdateTrainingProfileRequestDTO} [iUpdateTrainingProfileRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (id, iUpdateTrainingProfileRequestDTO, options) {
            return localVarFp.updateProfile(id, iUpdateTrainingProfileRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrainingProfileApiFactory = TrainingProfileApiFactory;
/**
 * TrainingProfileApi - object-oriented interface
 * @export
 * @class TrainingProfileApi
 * @extends {BaseAPI}
 */
var TrainingProfileApi = /** @class */ (function (_super) {
    __extends(TrainingProfileApi, _super);
    function TrainingProfileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Creates a training profile
     * @param {ICreateTrainingProfileRequestDTO} [iCreateTrainingProfileRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingProfileApi
     */
    TrainingProfileApi.prototype.createProfile = function (iCreateTrainingProfileRequestDTO, options) {
        var _this = this;
        return (0, exports.TrainingProfileApiFp)(this.configuration).createProfile(iCreateTrainingProfileRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a training profile
     * @param {string} id Training profile id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingProfileApi
     */
    TrainingProfileApi.prototype.deleteProfile = function (id, options) {
        var _this = this;
        return (0, exports.TrainingProfileApiFp)(this.configuration).deleteProfile(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all training profiles associated with context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingProfileApi
     */
    TrainingProfileApi.prototype.findAllProfiles = function (options) {
        var _this = this;
        return (0, exports.TrainingProfileApiFp)(this.configuration).findAllProfiles(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves training profile by id
     * @param {string} id Training profile id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingProfileApi
     */
    TrainingProfileApi.prototype.findProfileById = function (id, options) {
        var _this = this;
        return (0, exports.TrainingProfileApiFp)(this.configuration).findProfileById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a training profile
     * @param {string} id Training profile id
     * @param {IUpdateTrainingProfileRequestDTO} [iUpdateTrainingProfileRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingProfileApi
     */
    TrainingProfileApi.prototype.updateProfile = function (id, iUpdateTrainingProfileRequestDTO, options) {
        var _this = this;
        return (0, exports.TrainingProfileApiFp)(this.configuration).updateProfile(id, iUpdateTrainingProfileRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrainingProfileApi;
}(base_1.BaseAPI));
exports.TrainingProfileApi = TrainingProfileApi;
